import { combineReducers } from 'redux';
import { currentError } from './currentError';

export default combineReducers({
    currentError
});
